import formatCount from '@UI/Pages/Administration/AiCosts/Helpers/formatCount';

/** A count followed by its noun, in the singular up to one ("0 audio", "1 audio", "2 audios"). */
const formatQuantity = (count: number, singular: string, plural: string): string => {
	return `${formatCount(count)} ${count > 1 ? plural : singular}`;
};

export default formatQuantity;
